
import trackers1 from "../Images/original.webp"
import trackers2 from "../Images/original(1).webp"
import trackers3 from "../Images/original(2).webp"
import trackers4 from "../Images/original(3).webp"
import trackers5 from "../Images/original(4).webp"

const trackersData = [
    {
        id: 1,
        src: trackers1,
        title: "Fitbit Inspire HR",
        price: "$99.95"
    },
    {
        id: 2,
        src: trackers2,
        title: "Fitbit Inspire",
        price: "$69.95"
    },
    {
        id: 3,
        src: trackers3,
        title: "Fitbit Charge 3 Special Edition",
        price: "$169.95"
    },
    {
        id: 4,
        src: trackers4,
        title: "Fitbit Charge 3",
        price: "$149.95"
    },
    {
        id: 5,
        src: trackers5,
        title: "Fitbit Ace 2",
        price: "$69.95"
    },

]

export default trackersData